module.exports = __webpack_public_path__ + "static/media/Balai Pustaka.d665f152.png";